import React from "react";
import TitledCard from "../../../../components/UI/TitledCard";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Email, Phone } from "@material-ui/icons";
import { formatDate } from "../../../../utilities/format";

const AdvisorInfoCard = (props) => {
  const { advisor } = props;
  return (
    <TitledCard titleText="Advisor">
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant={"h5"} gutterBottom>
            {advisor.fullName}
          </Typography>
          <Typography variant={"body1"} gutterBottom>
            <Email fontSize={"inherit"} />{" "}
            <a
              href={`mailto: ${advisor.email}`}
              target={"_blank"}
              rel="noopener"
            >
              {advisor.email}
            </a>
          </Typography>
          <Typography variant={"body1"} gutterBottom>
            <Phone fontSize={"inherit"} /> {advisor.phone || "--"}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant={"caption"} color={"primary"}>
            Address
          </Typography>
          <Typography variant={"body1"} gutterBottom>
            {advisor.streetAddress} <br />
            {advisor.city}, {advisor.state} {advisor.zipCode}
          </Typography>

          <Typography variant={"caption"} color={"primary"}>
            Created
          </Typography>
          <Typography variant={"body1"} gutterBottom>
            {formatDate(advisor.createdAt)}
          </Typography>

          <Typography variant={"caption"} color={"primary"}>
            BD Affiliation
          </Typography>
          <Typography variant={"body1"} gutterBottom>
            {advisor.bdAffiliation || "--"}
          </Typography>

          <Typography variant={"caption"} color={"primary"}>
            CRD
          </Typography>
          <Typography variant={"body1"} gutterBottom>
            {advisor.advisorCrdRef}
          </Typography>
        </Grid>
      </Grid>
    </TitledCard>
  );
};

AdvisorInfoCard.propTypes = {
  advisor: PropTypes.object.isRequired,
};

export default AdvisorInfoCard;



// WEBPACK FOOTER //
// ./src/containers/AdminAdvisorDetail/components/AdvisorInfoCard/index.jsx